export default __webpack_public_path__ + "106082d4.jpg";